import React from "react";
import { motion } from "framer-motion";
import { FaUsers, FaShieldAlt, FaTools, FaRocket } from "react-icons/fa";

import { 
  Container, 
  Title, 
  Content, 
  Feature, 
  FeatureIcon, 
  FeatureText,
  FeatureGrid
} from "./styles";

function AboutSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren"
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <Container
      as={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <Title as={motion.h2} variants={itemVariants}>
        Sobre a nossa nova equipe ATLAS
      </Title>
      
      <Content as={motion.div} variants={itemVariants}>
        <p>
          Sob nova administração, a equipe Atlas está empenhada em oferecer um atendimento excepcional aos nossos clientes.
          Nosso foco é alcançar a melhor qualidade do mercado em plugins para Minecraft.
        </p>
        
        <FeatureGrid>
          <Feature as={motion.div} variants={itemVariants}>
            <FeatureIcon>
              <FaRocket />
            </FeatureIcon>
            <FeatureText>
              <h3>Inovação Constante</h3>
              <p>Estamos continuamente aprimorando nossas tecnologias para garantir que nossos futuros lançamentos sejam inovadores e impressionantes.</p>
            </FeatureText>
          </Feature>
          
          <Feature as={motion.div} variants={itemVariants}>
            <FeatureIcon>
              <FaShieldAlt />
            </FeatureIcon>
            <FeatureText>
              <h3>Proteção Garantida</h3>
              <p>Para assegurar a proteção dos seus plugins, contamos com um sistema robusto contra roubo, permitindo que você desative seus plugins sempre que desejar.</p>
            </FeatureText>
          </Feature>
          
          <Feature as={motion.div} variants={itemVariants}>
            <FeatureIcon>
              <FaTools />
            </FeatureIcon>
            <FeatureText>
              <h3>Suporte Contínuo</h3>
              <p>Se você já possui plugins da Atlas, fique tranquilo: continuaremos oferecendo suporte contínuo para garantir o melhor desempenho.</p>
            </FeatureText>
          </Feature>
          
          <Feature as={motion.div} variants={itemVariants}>
            <FeatureIcon>
              <FaUsers />
            </FeatureIcon>
            <FeatureText>
              <h3>Atendimento de Qualidade</h3>
              <p>Nossa prioridade é proporcionar uma experiência excepcional para todos os nossos clientes, com respostas rápidas e soluções eficientes.</p>
            </FeatureText>
          </Feature>
        </FeatureGrid>
      </Content>
    </Container>
  );
}

export default AboutSection;
